import * as React from "react";
import {
  container,
  styledRoomCard,
  styledModal,
  promoBadge,
  urgencyBadge,
} from "./RoomCard.module.scss";
import Modal from "react-bootstrap/Modal";
import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";

export const Container: React.FC<any> = (props) => {
  return <div className={container}>{props.children}</div>;
};

export const StyledRoomCard: React.FC<any> = (props) => {
  return (
    <Card
      id={props.id}
      className={styledRoomCard}
      style={props.isCurrentRoom ? { border: "none" } : {}}
    >
      {props.children}
    </Card>
  );
};

export const StyledModal: React.FC<any> = (props) => {
  return (
    <Modal className={styledModal} {...props}>
      {props.children}
    </Modal>
  );
};

export const PromoBadge: React.FC<any> = (props) => {
  return (
    <Badge id={props.id} className={promoBadge}>
      {props.children}
    </Badge>
  );
};

export const UrgencyBadge: React.FC<{
  children: JSX.Element;
  style: { backgroundColor: string; color: string };
  id: any;
}> = (props) => {
  return (
    <Badge id={props.id} className={`${urgencyBadge}`}>
      {props.children}
    </Badge>
  );
};
